import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ColorPicker } from 'primereact/colorpicker';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { toast } from 'react-toastify';
import {
  iPhone11,
  iPhone13,
  just_clickaway,
  priorityicon14,
  priorityicon15,
  priorityicon16,
  priorityicon17,
} from '@/utils/imagepath';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

function MobileAppSectionEditModal({ themeData, getThemeData }: any) {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);

  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [bannerImages, setBannerImages] = useState<string[]>([]);
  const [iconImages, setIconImages] = useState<string[]>([]);

  const images: Array<string> = [
    iPhone11,
    iPhone13,
    just_clickaway,
    iPhone11,
    iPhone13,
    just_clickaway,
  ];
  const icons = [
    priorityicon14,
    priorityicon15,
    priorityicon16,
    priorityicon17,
  ];
  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_4.home.section_11.check_list,
    ];

    let newCard = {
      icons: priorityicon14,
      title: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_11: {
            ...prevJsonData.theme_4.home.section_11,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_4.home.section_11.check_list,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_11: {
            ...prevJsonData.theme_4.home.section_11,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_4.home.section_11.check_list,
    ];
    if (index != undefined) {
      updatedCollection = [...editData.theme_4.home.section_11.check_list];

      updatedCollection[index] = {
        ...updatedCollection[index],
        title:
          name === 'check_list.title'
            ? value
            : updatedCollection.home.section_11.check_list.title,
      };
    }

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_11: {
            ...prevJsonData.theme_4.home.section_11,
            [name]: value,
            title:
              name === 'section_11.title'
                ? value
                : prevJsonData.theme_4.home.section_11.title,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };
  const handleImageChangeone = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_11: {
            ...prevJsonData.theme_4.home.section_11,
            banner: image,
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [...editData.theme_4.home.section_11.check_list];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icons: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_11: {
            ...prevJsonData.theme_4.home.section_11,
            ...prevJsonData.theme_4.home.section_11.check_list,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    // if (imageLink != false && bannerImageChange == false) {
    //   handleImageChange(imageLink, activeTab);
    // }
    if (imageLink != false) {
      handleImageChangeone(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    // setBannerImageChange(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  // Auto-generate prompt based on mobile app section context for Banner
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_4?.home?.section_11?.title || '';
    const paragraph = editData?.theme_4?.home?.section_11?.paragraph || '';
    
    let contextPrompt = 'modern professional image for mobile app section banner';
    
    if (title || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern aesthetic, professional mobile app mockup, smartphone display, suitable for mobile app section, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI banner image save
  const handleAIImageSaveBanner = (imageUrl: string) => {
    handleImageChangeone(imageUrl);
    setBannerImages(prevImages => [...prevImages, imageUrl]);
    
    const templateKey = template ? `template${template}` : 'template4';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  // Auto-generate prompt based on current card context for Icon
  const generateAutoPromptIcon = (): string => {
    const currentCard = editData?.theme_4?.home?.section_11?.check_list?.[activeTab];
    const cardTitle = currentCard?.title || '';
    const sectionTitle = editData?.theme_4?.home?.section_11?.title || '';
    const sectionParagraph = editData?.theme_4?.home?.section_11?.paragraph || '';
    
    let contextPrompt = 'modern minimalist icon design';
    
    if (cardTitle || sectionTitle || sectionParagraph) {
      const contextParts: string[] = [];
      if (sectionParagraph) {
        const keywords = sectionParagraph.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern minimalist icon, professional design, suitable for mobile app feature icon, vibrant colors, high quality, simple and recognizable, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    handleImageChange(iconUrl, activeTab);
    setIconImages(prevIcons => [...prevIcons, iconUrl]);
    
    const templateKey = template ? `template${template}` : 'template4';
    const currentTemplate = templateImages[templateKey] || {};
    const currentIcons = currentTemplate.icon || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        icon: [...currentIcons, { url: iconUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template4';
      const currentTemplate = templateImages[templateKey];
      const imageImgs = currentTemplate?.image || [];
      const iconImgs = currentTemplate?.icon || [];
      
      // Helper function to load image dimensions
      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ url, width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve(null);
          };
          img.src = url;
        });
      };

      // Load and filter banner images (square from image array)
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterBannerImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setBannerImages(squareImages);
        };

        filterBannerImages();
      } else {
        setBannerImages([]);
      }

      // Load and filter icon images
      if (Array.isArray(iconImgs) && iconImgs.length > 0) {
        const filterIconImages = async () => {
          const iconPromises = iconImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedIcons = await Promise.all(iconPromises);
          
          // Filter for square/icon images (aspect ratio 0.9-1.1)
          const squareIcons = loadedIcons
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setIconImages(squareIcons);
        };

        filterIconImages();
      } else {
        setIconImages([]);
      }
    } else {
      setBannerImages([]);
      setIconImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section11 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="section_11.title"
                      value={editData?.theme_4?.home?.section_11?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="mobile_app_description"
                        placeholder="Describe the mobile app. Example: 'Write about our mobile application features'"
                        context="This is for the mobile app section paragraph"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_4?.home?.section_11?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_4?.home?.section_11?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_11?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_4?.home?.section_11?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_11?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_4?.home?.section_11?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_4?.home?.section_11?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_4?.home?.section_11?.check_list.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Check List {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_4?.home?.section_11?.check_list?.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <label className="form-label">Checklist Icon</label>
                          <div className="img-bg active">
                            <img
                              src={card.icons}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((iconUrl: string, iconIndex: number) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(iconUrl, index)
                                      }
                                    >
                                      <img
                                        src={iconUrl}
                                        alt="Hero Image"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-icons fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* AI Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="check_list.title"
                          value={card.title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>

                      <div className="add-section mb-3">
                        <div className="row">
                          <div
                            onClick={() => {
                              addCollection();
                            }}
                            className="col text-center"
                          >
                            Add Card<i className="fas fa-plus-square ms-2"></i>
                          </div>
                        </div>
                      </div>

                      <div className="mb-1">
                        <div className="row">
                          <div className="col-md-12">
                            <label className="form-label">
                              Background Banner
                            </label>
                            <div className="img-bg active">
                              <img
                                src={
                                  editData?.theme_4?.home?.section_11?.banner
                                }
                                alt="Hero Image"
                              />
                            </div>
                            <div className="img-options">
                              <div className="row">
                                <div className="col-md-12">
                                  {bannerImages.length > 0 ? (
                                    <Swiper
                                      spaceBetween={15}
                                      navigation={true}
                                      modules={[Navigation]}
                                      breakpoints={{
                                        640: {
                                          slidesPerView: 1,
                                        },
                                        768: {
                                          slidesPerView: 4,
                                        },
                                        1024: {
                                          slidesPerView: 6,
                                        },
                                      }}
                                      className="homejson-slider"
                                    >
                                      {bannerImages.map((imageUrl: string, idx: number) => {
                                        return (
                                          <SwiperSlide key={idx}>
                                            <div
                                              className="img-option"
                                              onClick={() =>
                                                handleImageChangeone(imageUrl)
                                              }
                                            >
                                              <img
                                                src={imageUrl}
                                                alt="Hero Image"
                                                className="img-fluid"
                                              />
                                            </div>
                                          </SwiperSlide>
                                        );
                                      })}
                                    </Swiper>
                                  ) : (
                                    <div className="empty-slider-state text-center py-4">
                                      <div className="empty-state-content">
                                        <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                        <h6 className="text-muted mb-2">No Banner Images Available</h6>
                                        <p className="text-muted small mb-3">
                                          Generate AI images or upload your own to see them here
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* AI Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptBanner}
                        onSave={handleAIImageSaveBanner}
                        imageType="image"
                        defaultWidth="1024"
                        defaultHeight="1024"
                        title="AI Banner"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionOne}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            {/* <div className="edit-section">
              <div className="row">
                <div className="col">
                  <h4>Mobile Link Section</h4>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Android Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="android_link"
                      value={
                        editData?.theme_4?.home?.section_11?.mobile_link_section
                          ?.android_link
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Ios Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ios_link"
                      value={
                        editData?.theme_4?.home?.section_11?.mobile_link_section
                          ?.ios_link
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div> */}
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default MobileAppSectionEditModal;
